jQuery(document).ready(function($) {

	let instructions = document.querySelectorAll('.photos-instruction');
	let photosContainer = document.querySelector('.photos-collage');
	let photoWrappers = document.querySelectorAll('.photo-wrapper');
	let photos = document.querySelectorAll('.photo');
	const masthead = document.getElementById('masthead');

	let photosRange = [-4, 4];
	let photoDrop = 300;

	let focusedWrapper;
	let cloneWrapper;
	
	// uses current state of photos to set click events
	let collageReset = () => {

		photoWrappers = document.querySelectorAll('.photo-wrapper');
		instructions = document.querySelectorAll('.photos-instruction');
		
		if (photoWrappers) {
			photoWrappers.forEach((photoWrapper, i) => {
				photoWrapper.removeEventListener('click', collageShuffle);
				photoWrapper.addEventListener('click', collageShuffle);
			});
		}

		if (instructions) {
			instructions.forEach((instruction) => {
				instruction.addEventListener('click', collageShuffle);
			});
		}
	};

	const collageRotatePhotos = (photos) => {

		// only rotate at md and higher
		photos.forEach((photo) => {
			if (window.innerWidth > 767) {
				let random = Math.floor(Math.random() * (photosRange[1] - photosRange[0] + 1)) + photosRange[0];
				photo.style.transform = "rotate(" + random + "deg)";
			} else {
				photo.style.transform = "rotate(0deg)";
			}
		});
	};

	// starts the collage by dropping in the photos and angling them
	const collageStart = () => {
		photos = document.querySelectorAll('.photo');
		
		if (photos.length) {

			collageRotatePhotos(photos);

			photoWrappers = document.querySelectorAll('.photo-wrapper');

			if (photoWrappers.length) {
				photoWrappers.forEach((photoWrapper, i) => {
					setTimeout(() => {
						photoWrapper.classList.add('active');
					}, photoDrop * (i + 1));
				});
				photoWrappers[0].classList.add('focus');
			}
		}

		let instructions = document.querySelectorAll('.photos-instruction');
		if (instructions != null) {
			instructions.forEach((instruction) => {
				setTimeout(() => {
					instruction.classList.add('active');
				}, 3000);
			});
		}
	};

	// shuffles the collage to put a new photo "on top"
	const collageShuffle = () => {

		photosContainer = document.querySelector('.photos-collage');

		if (photosContainer) {
			focusedWrapper = photosContainer.querySelector('.focus');
			focusedWrapper.classList.remove('focus');
			focusedWrapper.classList.add('unfocus');
			photosContainer.children[1].classList.add('focus');

			//swap low-res image for high-res one for next images in line
			photosContainer.children[4].classList.add('loading');
			photosContainer.children[4].querySelector('.photo').setAttribute('src', photosContainer.children[4].querySelector('.photo').dataset.highRes);

			setTimeout(() => {
				cloneWrapper = focusedWrapper.cloneNode([true]);
				cloneWrapper.classList.remove('unfocus');
				cloneWrapper.classList.remove('focus');
				focusedWrapper.remove();

				photosContainer.append(cloneWrapper);
			}, 500);
		}

		collageReset();
	};


	// make masthead transparent until scrolled
	if (masthead) {
		masthead.style.backgroundColor = 'transparent';
		masthead.style.backgroundImage = 'none';
	}

	collageStart();
	collageReset();	

	const resizeFunctions = () => {
		collageRotatePhotos(photos);
	};
	// run functions when screensize changed
	window.addEventListener('resize', resizeFunctions, false);

});